import React from "react";
import { Input } from "reactstrap";
import { CustomInputProps } from "./type";
import "./style.scss";

/**
 * Yeni nesil metin/sayı/tarih alanı.
 * Floating-label KALDIRILDI → üstte net etiket + belirgin kenarlıklı kutu.
 * (Eski görünmez input tasarımı tamamen atıldı.)
 */
const CustomInput = ({
  type = "text",
  label,
  error,
  name,
  touched,
  options,
  placeholder,
  labelProps,
  className,
  onChange,
  ...props
}: CustomInputProps) => {
  const invalid = !!(error && touched);
  return (
    <div className={"m-field " + (className ?? "")}>
      {label && (
        <label className="m-field__label" htmlFor={name} {...labelProps}>
          {label}
        </label>
      )}
      <Input
        id={name}
        placeholder={placeholder}
        name={name}
        type={type}
        className={"m-input" + (invalid ? " is-invalid" : "")}
        onChange={onChange}
        {...props}
      />
      {invalid && <div className="m-field__error">{error}</div>}
    </div>
  );
};
export default CustomInput;
